import React from "react";
import { useIntl } from "react-intl";
import { TwoRow } from "../../core/layouts";
import { Text, Checkbox } from "react_reusable_components";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import UserOperationAndRepairAuditLayout from "../../layouts/UserOperationAndRepairAuditLayout";
import variables from "../../themes/base/styles/variables";

const OperationAndRepairAuditContainerStyle = {
  headerText: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightNormal,
    color: variables.textDefault,
    marginTop: variables.marginSmall,
  },
  sectionStyle: {
    marginTop: variables.marginMedium,
  },
  bottomSectionStyle: {
    marginTop: variables.marginMediumLarge1,
  },
  checkboxTextStyle: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    color: variables.textDefault,
    justifyContent: variables.spaceBetween,
  },
};

export default function OperationAndRepairAuditContainer({
  roleName,
  disableOperationAudit,
  isOperationAudit,
  isRepairAudit,
  setIsOperationAudit,
  setIsRepairAudit,
}) {
  const intl = useIntl();

  const operationAuditHandler = (checked) => {
    setIsOperationAudit(checked);
  };
  const repairAuditHandler = (checked) => {
    setIsRepairAudit(checked);
  };

  return (
    <TwoRow
      topSection={
        <Text style={OperationAndRepairAuditContainerStyle.headerText}>
          {roleName === "TM"
            ? getLocalizedMessage(intl, "addUser.text.operationAndRepairAudit")
            : getLocalizedMessage(intl, "addUser.text.repairDoneAudit")}
        </Text>
      }
      style={OperationAndRepairAuditContainerStyle.sectionStyle}
      bottomSection={
        <UserOperationAndRepairAuditLayout
          topSection={
            <Checkbox
              onChange={(e) => operationAuditHandler(e.target.checked)}
              style={OperationAndRepairAuditContainerStyle.checkboxTextStyle}
              text={getLocalizedMessage(intl, "addUser.text.operationAudit")}
              checked={roleName === "DNSD" ? true : isOperationAudit}
              disabled={disableOperationAudit}
            />
          }
          bottomSection={
            <Checkbox
              onChange={(e) => repairAuditHandler(e.target.checked)}
              style={OperationAndRepairAuditContainerStyle.checkboxTextStyle}
              text={getLocalizedMessage(intl, "addUser.text.repairAudit")}
              checked={isRepairAudit}
            />
          }
        />
      }
      bottomSectionStyle={
        OperationAndRepairAuditContainerStyle.bottomSectionStyle
      }
    />
  );
}
